import { render, staticRenderFns } from "./ToPay.vue?vue&type=template&id=bf846902&"
import script from "./ToPay.vue?vue&type=script&lang=js&"
export * from "./ToPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports